import { BL1Icon, BL2Icon, BL3Icon, BSG1Icon, BSG2Icon, Intelli1Icon, Intelli2Icon, Intelli3Icon, Intelli4Icon, Intelli5Icon, JP1Icon, JP2Icon, JP3Icon, JpMorgon1Icon, JpMorgon2Icon, JpMorgon3Icon, LocalPower1Icon, LocalPower2Icon, LocalPower3Icon, LocalPower4Icon, Ml1Icon, Ml2Icon, Ml3Icon, UG1Icon, UG2Icon, UG3Icon, UG4Icon, UG5Icon, VB1Icon, VB2Icon} from "../assests";

// --------------------------------------- Project List

export const ProjectList = [
    {
        img: Intelli4Icon,
        imgs: [Intelli1Icon, Intelli2Icon, Intelli3Icon, Intelli4Icon, Intelli5Icon],
        title: "IntelliRecruit",
        description: " Recruiting Software to Streamline Hiring, Improve Hire Quality & Manage Administrative Tasks. IntelliRecruit helps your company build a recruiting process to fit your needs.",
        tech_stack: ["React", 'Redux', 'NodeJS', 'Swagger', 'MongoDB', 'ExpressJS', 'AI', 'Python'],
        github_url: "",
        demo_url: "https://intelli-recruit.netlify.app",
    },
    {
        img: LocalPower1Icon,
        imgs: [LocalPower1Icon, LocalPower2Icon, LocalPower3Icon, LocalPower4Icon],
        title: "Localpower.io",
        description:
            "Localpower.io is an industry-leading solar design and proposal tool to help solar installers automate, structure and scale their business.",
        tech_stack: [ 'AWS Amplify', 'Cognito', 'Lambda', 'Appsync', 'GraphQL', 'ReactJS', 'MUI'],
        github_url: "",
        demo_url: "https://localpower.io/",
    },
    {
        img: Ml1Icon,
        imgs: [Ml1Icon, Ml2Icon, Ml3Icon],
        title: "Mealpackz",
        description: "An online food ordering system. The customers use the platform to search and discover restaurants, read and write customer generated reviews and view and upload photos, order food delivery, book an order and make payments",
        tech_stack: ['NodeJS', 'VueJS', 'Vuex', 'MySQL', 'SocketIO', 'Maps', 'Charts', 'Bootstrap'],
        github_url: "",
        demo_url: "https://wappnet.com/mealpackz",
    },
    {
        img: VB1Icon,
        imgs: [VB1Icon, VB2Icon],
        title: "Vibecoin",
        description: "Vibecoin is a block chain-enabled commerce platform that makes it easier and cheaper to acquire new customers with a new crypto",
        tech_stack: ['NodeJS', 'ExpressJS', 'Sequelize', 'socket.io', 'swagger API', 'EJS template'],
        github_url: "",
        demo_url: "https://wappnet.com/vibecoin",
    },
    {
        img: BL1Icon,
        imgs: [BL1Icon, BL2Icon, BL3Icon],
        title: "Bellesa | Sextoylab",
        description: "Online portfolio site and Admin panel for inventory store system",
        tech_stack: ['ReactJS', 'NextJS', 'GraphQL', 'MongoDB', 'KeystoneJS', 'Styles-components'],
        github_url: "",
        demo_url: "https://sextoylab.com",
    },
    {
        img: BSG2Icon,
        imgs: [BSG1Icon, BSG2Icon],
        title: "BSG | Callupper",
        description: "The BSG MVNO project involved the development of a dashboard for the Mobile Virtual Network Operator (MVNO). As an MVNO, BSG acts as a reseller for wireless communication services, leveraging existing network infrastructure without holding a personal licensed frequency allocation",
        tech_stack: ['ReactJS', 'Redux', 'axios', 'Maps', 'Charts', 'Bootstrap'],
        github_url: "",
        demo_url: "https://callupper.com",
    },
    {
        img: UG1Icon,
        imgs: [UG1Icon, UG2Icon, UG3Icon, UG4Icon, UG5Icon],
        title: "Unitgrid",
        description: "A single gateway to access your power profile by measuring live electricity generation and consumption",
        tech_stack: ['ReactJS', 'Redux', 'Golong', 'IoT', 'Charts'],
        github_url: "",
        demo_url: "https://unitgrid.in/",
    },
    {
        img: JP1Icon,
        imgs: [JP1Icon, JP2Icon, JP3Icon],
        title: "Covr Advisor | JP Morgon",
        description: "The concept behind this project is to Provide the insurance services to the customers from the different banks. This project is mainly made for the insurance agents for work purpose.This project is digital, white-labeled platform integrate seamlessly with the financial brands to provide life, long-term care, and health solutions from top carriers to their clients in a simple way.",
        tech_stack: ['ReactJS', 'Redux', 'MUI', 'Typescript'],
        github_url: "",
        demo_url: "",
    },
];

// --------------------------------------- Skills

export const stackList = [
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
        name: "HTML",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
        name: "CSS",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
        name: "JavaScript",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
        name: "ReactJS",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
        name: "Bootstrap",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
        name: "Git",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
        name: "React Native",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
        name: "NodeJS",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/firebase/firebase-plain.svg",
        name: "Firebase",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
        name: "MongoDB",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        name: "Python",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original.svg",
        name: "Flask",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
        name: "C",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        name: "Java",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
        name: "MySQL",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
        name: "Material UI",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
        name: "Figma",
    },
    {
        img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
        name: "VS Code",
    },
];
